// Accent/diacritic-insensitive substring search helpers for the quick-search sheet.
export const normalize = (s) =>
  String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f\u064B-\u0652]/g, "").replace(/[’'`ʻ]/g, "");

// All language variants of a {id,en,ar,…} map (or a plain string) joined for matching.
export const textOf = (v) => (v && typeof v === "object" ? Object.values(v).join(" ") : String(v || ""));

export const matches = (haystack, q) => normalize(haystack).includes(normalize(q));

export const searchItems = (items, q, limit = 5) => items.filter((it) => matches(it.hay, q)).slice(0, limit);
